import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  fuelTypesCountState,
  fuelTypeSearchOptionsSelector,
  fuelTypesState,
  hasSelectedFuelTypesFilterSelector,
  resetSelectedFuelTypesSelector,
  selectedFuelTypesSelector,
  selectFuelTypeSelector,
  toggleFuelTypeSelector,
  visibleFuelTypeSelector,
} from '@/states/filters/fuel-type.state';

export function useFuelTypeFilter() {
  const [fuelTypeFilter, setFuelTypeFilter] = useRecoilState(fuelTypesState);
  const [fuelTypeCount, setFuelTypeCount] = useRecoilState(fuelTypesCountState);
  const fuelTypeSearchOptions = useRecoilValue(fuelTypeSearchOptionsSelector);
  const toggleFuelType = useSetRecoilState(toggleFuelTypeSelector);
  const selectFuelType = useSetRecoilState(selectFuelTypeSelector);
  const selectedFuelTypes = useRecoilValue(selectedFuelTypesSelector);
  const visibleFuelTypeFilter = useRecoilValue(visibleFuelTypeSelector);
  const resetSelectedFuelTypes = useSetRecoilState(
    resetSelectedFuelTypesSelector
  );
  const hasSelectedFuelTypesFilter = useRecoilValue(
    hasSelectedFuelTypesFilterSelector
  );

  return {
    fuelTypeFilter,
    setFuelTypeFilter,
    fuelTypeCount,
    setFuelTypeCount,
    fuelTypeSearchOptions,
    toggleFuelType,
    selectFuelType,
    selectedFuelTypes,
    resetSelectedFuelTypes,
    hasSelectedFuelTypesFilter,
    visibleFuelTypeFilter,
  };
}
